exports = module.exports = require("./../../node_modules/.npminstall/css-loader/0.23.1/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%;font-family:Roboto,sans-serif;line-height:1.5}body{margin:0}*,:after,:before{box-sizing:border-box}img{width:100%}.paper{background:#fff;box-shadow:0 1px 6px rgba(0,0,0,.117647),0 1px 4px rgba(0,0,0,.117647)}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/css-loader/0.23.1/css-loader!./~/.npminstall/postcss-loader/0.8.2/postcss-loader!./~/.npminstall/less-loader/2.2.3/less-loader!./src/components/app.less
 ** module id = 517
 ** module chunks = 0
 **/